import { compose, withProps } from 'recompose'
import { injectIntl } from 'react-intl'
import { scrollTo } from '../../../helpers/browser'

const HomeownerReportVideoSectionContainer = compose(withProps({ onClick: scrollTo }), injectIntl)

export default HomeownerReportVideoSectionContainer
